const getHandledKeyName = (key) => {
    return key?.replace(/_/g, '-') // Changing '_' to '-', symbol, this array will always come with keys using '_'
}

export const getCombinedVarsObject = (vars, newVars) => {
    const result = { ...vars }

    for (let key in newVars) {
        if (result.hasOwnProperty(getHandledKeyName(key))) {
            result[getHandledKeyName(key)] = newVars[key]
        }
    }

    return result
}

export const convertJSONStylesToGlobalVarsContent = (json, newValuesJson = null) => {
    let cssVariables = ''
    const handledVars = getCombinedVarsObject(json, newValuesJson || {})

    for (const [key, value] of Object.entries(handledVars)) {
        cssVariables += `--${key}: ${value};`
    }

    return `:root {${cssVariables}}`
}